import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsManagementModule } from './forms-management/forms-management.module'
import { LandingPagesModule } from './landing-pages/landing-pages.module';
import { ContentfulService } from './_services/contentful.service';
import { HttpClientModule } from '@angular/common/http';
import { LayoutMangmentModule } from './layout-mangment/layout-mangment.module';
import { SafeStringPipe } from './_pipes/safe-string.pipe';
import { MdToHtmlPipe } from './_pipes/md-to-html.pipe';
import { RichTextPipe } from './_pipes/rich-text.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InterpolatePipe } from './_pipes/interpolate.pipe';
import { GoogleMapsModule } from '@angular/google-maps';


@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    FormsManagementModule,
    LandingPagesModule,
    LayoutMangmentModule,
    HttpClientModule,
    SafeStringPipe,
    MdToHtmlPipe,
    RichTextPipe,
    BrowserAnimationsModule,
    InterpolatePipe,
    CommonModule,
    GoogleMapsModule,
    RouterModule.forRoot([]) 
  ],
  providers: [
    ContentfulService, 
    CurrencyPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
